import { Injectable } from "@angular/core";
import { BreeceApiService } from "../breece-api.service";
import { map, Observable } from "rxjs";
import { IBreeceSelectorsResponse } from "./response/breece-selectors.response";
import { mapBreeceSelectors } from "./mapper/system.mapper";
import { BreeceSelectorDetails } from "./models/breece-selector-details.model";

@Injectable({
    providedIn: 'root'
  })
export class SystemApiService extends BreeceApiService {

    getBreeceSelectors(enumName: string, enumLocation: string): Observable<BreeceSelectorDetails[]> {
        return this.get<IBreeceSelectorsResponse>('/System/enum', [{ value: enumName, key: 'enumName' }, { value: enumLocation, key: 'localizationLocation' }])
            .pipe(map((response) => mapBreeceSelectors(response, enumName)));
    }
}